import React from "react";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";

export default function RowEditButton({ uri }) {
  const history = useHistory();
  return (
    <div>
      <Button
      className="flex flex-col"
        onClick={() => {
          history.push(uri);
        }}
        variant="warning"
        size="md"
        title="Edit"
      >
        <i className="fa fa-edit text-blueGray-500" />
      </Button>
    </div>
  );
}
